import Joi from "joi";

export const designationValidationSchema = Joi.object({
  status: Joi.boolean().required().messages({
    "boolean.pattern.base": "Status is required.",
    "boolean.empty": "Status is required.",
    "any.invalid": "Status is required.",
  }),
  designationName: Joi.string().min(2).max(100).required().messages({
    "string.empty": "Designation Name is required.",
    "string.base": "Designation Name is required.",
    "string.required": "Designation Name is required.",
    "string.invalid": "Designation Name is required.",
    "string.max": "Designation Name must not exceed 100 characters.",
    "string.min": "Designation name must be at least 2 characters.",
    "any.required": "Designation Name is required.",
  }),
  dept_id: Joi.number()
  .required()
  .messages({
    "any.required": "Department is required",
    "number.base": "Department is required",
  })
});

// dept_id

// status